<template>
  <div
    class="scene-card-user-images-parts"
    v-if="otherCommentUsers && otherCommentUsers.length > 0"
  >
    <div class="scene-card-user-images-parts__users">
      <figure
        v-for="user in otherCommentUsers"
        :key="`commentUser${user.id}`"
        class="scene-card-user-images-parts__user-image"
      >
        <img :src="user.userPicture" alt="" />
      </figure>
    </div>

    <p
      class="scene-card-user-images-parts__surplus-count"
      v-if="userSurplusCount > 0"
      v-text="`+${userSurplusCount}`"
    />
  </div>
</template>

<script lang="ts">
import { computed, defineComponent, PropType } from '@vue/composition-api'
import type { OtherCommentUserType } from '@/components/HomePage/HomePane/parts/SceneListCardParts.vue'

/**
 * HOME ハイライトシーンリスト その他ユーザー画像表示パーツ
 */
export default defineComponent({
  name: 'SceneCardUserImagesParts',
  props: {
    /**
     * その他直近コメントユーザー
     */
    otherCommentUsers: {
      type: Array as PropType<OtherCommentUserType[]>,
    },
    /**
     * コメント数
     */
    commentCount: {
      type: Number,
    },
  },
  setup(props) {
    /**
     * コメントユーザーの残り人数取得
     */
    const userSurplusCount = computed(() => {
      const totalCommentCount = props.commentCount ?? 0
      const otherCommentCount = props.otherCommentUsers?.length ?? 0
      // コメント数 - アイコンを表示しているユーザー数（最大3人） - 対象カードのユーザー（1人）
      return totalCommentCount - otherCommentCount - 1
    })

    return {
      userSurplusCount,
    }
  },
})
</script>

<style lang="scss" scoped>
.scene-card-user-images-parts {
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 3px;
  padding: 3px;
  height: 24px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 50px;

  &__users {
    display: inline-flex;
    flex-flow: row nowrap;
    align-items: center;
    justify-content: flex-start;
  }

  &__user-image {
    display: flex;

    + .scene-card-user-images-parts__user-image {
      margin-left: -5px;
    }

    img {
      width: 18px;
      height: 18px;
      object-fit: cover;
      border-radius: 50%;
      background: $white;
    }
  }

  &__surplus-count {
    margin-right: 6px;
    font-weight: 500;
    font-size: 10px;
    line-height: 1.2;
    letter-spacing: 0.04em;
    color: $black20;
  }
}
</style>
